module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "uprights"
    }
  }, [(_vm.configurator === 'k1') ? _c('k1uprights') : _vm._e(), _vm._v(" "), (_vm.configurator === 'k1_wall') ? _c('k1walluprights') : _vm._e(), _vm._v(" "), (_vm.configurator === 'k2') ? _c('k2uprights') : _vm._e(), _vm._v(" "), (_vm.configurator === 'krossing') ? _c('krossinguprights') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d93279b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/views/Uprights.vue
// module id = 632
// module chunks = 0